<script lang="ts">

    import { BENEFIT_INFO_LIST } from '../constants/common';
    import { themeType as ThemeTypeEnum } from '../constants/Enums';
    import { BENEFIT_ONE } from '../constants/imgList';

    import webp from '@/actions/webp';

    export let themeType: ThemeTypeEnum = ThemeTypeEnum.WHITE;
    export let benefitInfoList = BENEFIT_INFO_LIST;

    interface TitlePartShape {
        text: string;
        color: string;
        /** 正文内强调片段（如 WHITE 主题下的 2% / 6%），非圆形 title */
        fontSize?: string;
        noWrap?: boolean;
    }

    function getTitleParts(benefit: Record<string, unknown>): TitlePartShape[] {
        const parts = benefit[themeType] as TitlePartShape[] | undefined;

        if (parts?.length) return parts;
        const fallback = benefit[ThemeTypeEnum.WHITE] as
            | TitlePartShape[]
            | undefined;

        return fallback ?? [];
    }

    function getAltText(benefit: Record<string, unknown>): string {
        return getTitleParts(benefit)
            .map((p) => p.text)
            .join('');
    }

    /** 如 "2%" / "6%"：数字 48px，% 24px */
    function splitPercentTitle(
        title: string
    ): { num: string; pct: string } | null {
        const m = /^(\d+)(%)$/.exec(title);

        if (!m) return null;

        return { num: m[1], pct: m[2] };
    }
</script>

<div
    class="benefit-info"
    class:benefit-info--black={themeType === ThemeTypeEnum.BLACK}
    class:benefit-info--white={themeType !== ThemeTypeEnum.BLACK}
>
    <div
        class="benefit-header"
        class:benefit-header--black={themeType === ThemeTypeEnum.BLACK}
        class:benefit-header--white={themeType !== ThemeTypeEnum.BLACK}
    >
        Beneficios
    </div>

    <div
    class="benefit-cards"
    >
        {#each benefitInfoList as benefit, i (benefit.icon ?? i)}
            <div class="benefit-card">
                {#if themeType === ThemeTypeEnum.BLACK}
                    {@const pctTitle = splitPercentTitle(String(benefit.title))}
                    <div class="title">
                        {#if pctTitle}
                            <span class="title__pct-wrap">
                                <span class="title__num">{pctTitle.num}</span><span
                                    class="title__pct">{pctTitle.pct}</span
                                >
                            </span>
                        {:else}
                            <span class="title__fallback">{benefit.title}</span>
                        {/if}
                        <span>Cashback</span>
                    </div>
                {/if}
                <div class="card-title" class:card-title--black={themeType === ThemeTypeEnum.BLACK}>
                    {#each getTitleParts(benefit) as part, idx (idx)}
                        {#if part.text === '\n'}
                            <br />
                        {:else}
                            <span
                                class:card-title__part--nowrap={part.noWrap}
                                style:color={part.color}
                                style:font-size={part.fontSize}
                            >{part.text}</span>
                            {#if idx < getTitleParts(benefit).length - 1 &&
                            getTitleParts(benefit)[idx + 1]?.text !== '\n'}
                                {' '}
                            {/if}
                        {/if}
                    {/each}
                </div>

                <div class="icon-box">
                    <img
                        use:webp
                        src={benefit.icon ?? BENEFIT_ONE}
                        alt={getAltText(benefit)}
                        loading="lazy"
                    />
                </div>
            </div>
        {/each}
    </div>
</div>

<style lang="scss" scoped>
    .benefit-info {
        width: 100%;
        max-width: 750px;
        padding: 0 32px;
        display: flex;
        flex-direction: column;

        &--black {
            padding: 0;
            .benefit-header {
                color: #ffffff;
            }

            .benefit-card {
                background-color: #111214;;
                height: 3.35rem;
                border: 0.86px solid #000000;
                background-color: #111214;

                .title > span:last-child {
                    font-family: DiDiSans-Pro-Regular;
                    font-size: 24px;
                    line-height: 40px;
                    color: #ffffff;
                }

                .title {
                    font-family: DiDiSans-Pro-Bold;
                    color: #ff5f14;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: baseline;
                    align-self: flex-start;
                    gap: 0 4px;
                }

                .title__pct-wrap {
                    display: inline-flex;
                    align-items: baseline;
                }

                .title__num {
                    font-size: 48px;
                    line-height: 40px;
                }

                .title__pct {
                    font-size: 24px;
                    line-height: 40px;
                }

                .title__fallback {
                    font-size: 48px;
                    line-height: 64px;
                }
            }
        }

        &--white {
            background-color: #ffffff;

            .benefit-header {
                color: #0c0c0d;
            }

            .benefit-card {
                background-color: #f2f2f5;
                height: 2.6rem;
            }
        }
    }

    .benefit-header {
        font-family: DiDiSans-Pro-Bold;
        font-size: 32px;
        line-height: 40px;
    }
    .benefit-header--black {
        margin: 0 0 32px 16px;
        opacity: 0.8;
    }
    .benefit-header--white {
        margin: 0 0 24px 8px;
    }

    .benefit-cards {
        width: 100%;
        display: flex;
        gap: 16px;
    }

    .benefit-card {
        width: 218px;
        height: 260px;
        border-radius: 16px;
        padding: 24px 22px 0 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        position: relative;
    }

    .card-title {
        font-family: DiDiSans-Pro-Bold;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        color: #111a34;
        word-break: break-word;
    }
    .card-title__part--nowrap {
        white-space: nowrap;
    }
    .card-title--black {
        font-family: DiDiSans-Pro-Regular;
        opacity: 0.8;
        margin-top: 0.08rem;
    }

    .icon-box {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 140px;
        height: 100px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        pointer-events: none;
    }

    .icon-box img {
        width: 140px;
        height: 100px;
        object-fit: contain;
    }
</style>
